// SVG stroke / axis-text styling helpers extracted verbatim from
// InteractiveGraph.js (IG-split Slice 4, pure-function seam). enforceStrokes and
// applyAxisTextStyles operate on a passed-in d3 selection (no component-state
// closure). DEFAULT_STAT_OUTLINE_COLOR moves with enforceStrokes (its only
// non-renderer consumer) and is re-exported for the renderer call sites that
// still reference it; STROKE_SKIP_CLASSES stays module-internal.
import * as d3 from 'd3';

export const DEFAULT_STAT_OUTLINE_COLOR = '#0f172a';

// Shape tags that should receive a default dark outline stroke.
// Text elements are explicitly excluded — they should use font-weight for emphasis.
export const STROKE_SHAPE_TAGS = new Set(['rect', 'circle', 'ellipse', 'path', 'polygon']);
const STROKE_SKIP_CLASSES = new Set([
  'overlay-tag', 'overlay-bold-bg', 'overlay-projection',
  'overlay-grid-line', 'overlay-pin-reference', 'overlay-pin-label', 'overlay-highlight'
]);

/**
 * enforceStrokes(svg) — Safety-net that ensures all visible data-element shapes
 * have a consistent dark outline. Call after rendering AND after overlay application.
 * Skips elements that already have a stroke set by the renderer or overlay,
 * and never touches <text> elements.
 */
export const enforceStrokes = (svg) => {
  if (!svg || !svg.node()) return;
  svg.selectAll('[data-element-id]').each(function () {
    const el = d3.select(this);
    const tagName = (this.tagName || '').toLowerCase();
    // Only shape elements — never text
    if (!STROKE_SHAPE_TAGS.has(tagName)) return;
    // Skip overlay-injected elements
    const classList = this.classList;
    if (classList) {
      for (const cls of STROKE_SKIP_CLASSES) {
        if (classList.contains(cls)) return;
      }
    }
    // Skip elements with an active overlay-pulse transition (don't fight the animation)
    if (d3.active(this, 'overlay-pulse')) return;
    // If element already has a stroke set by the renderer/overlay, leave it alone
    const currentStroke = el.attr('stroke');
    if (currentStroke && currentStroke !== 'none' && currentStroke !== 'null') return;
    // Apply default dark outline
    el.attr('stroke', DEFAULT_STAT_OUTLINE_COLOR);
    el.attr('stroke-width', 1.5);
  });
};

export const applyAxisTextStyles = (selection, fill, fontWeight) => {
  if (!selection) return;
  selection.style('fill', fill).style('font-weight', fontWeight);
};
